import { MultiSubmissionConfig } from '../types';

export const competition14MultiSubmissionConfig: MultiSubmissionConfig = {
  key: 'competition_14',
  title: 'Submission',
  submitLabel: 'Submit',
  description: 'Complete all required fields before submitting your project.',
  fields: [
    {
      id: 'video_link',
      type: 'url',
      label: 'Link to video',
      required: true,
      placeholder: 'https://...',
    },
    {
      id: 'agent_link',
      type: 'url',
      label: 'Link to agent',
      required: true,
      placeholder: 'https://...',
    },
    {
      id: 'presentation_pdf',
      type: 'file',
      label: 'PDF file for presentation',
      required: true,
      accept: '.pdf,application/pdf',
    },
    {
      id: 'submission_title',
      type: 'text',
      label: 'Project title',
      required: true,
      placeholder: 'Enter your project title',
    },
    {
      id: 'brief_text',
      type: 'textarea',
      label: 'Brief explanation',
      required: true,
      placeholder: 'Describe your project, approach, and expected impact.',
      helpText: 'Maximum 200 words.',
      maxWords: 200,
    },
    {
      id: 'track',
      type: 'select',
      label: 'Track',
      required: true,
      options: [
        { value: 'finance_accounting', label: 'Finance & Accounting' },
        { value: 'business_technology', label: 'Business Technology' },
        { value: 'hr', label: 'HR' },
        { value: 'marketing_sales', label: 'Marketing & Sales' },
        { value: 'general_innovation', label: 'General Innovation' },
      ],
    },
  ],
};
